import {LeaderboardStrategy} from "./leaderboardStrategy";
import {UserWithStats} from "../UserWithStats";
import React from "react";
import {TFunction} from "i18next";
import { getRelativeTime } from "../../utils";


export class LeaderboardStrategyFastaily extends LeaderboardStrategy {
    getGamemodeInformations(t: TFunction<"translation", undefined>, userStats: UserWithStats): React.ReactNode {
        return <>
            <p className={"w-1/6"}>{t("stats.score-x", {score: userStats.best})}</p>
            <p className={"w-1/6"}>{getRelativeTime(t, userStats.dateBest)}</p>
        </>;
    }

    getGamemodeSubtitle(t: TFunction<"translation", undefined>): string {
        return t("leaderboard.leaderboard-of-the-day");
    }
}
